import { put, takeLatest } from 'redux-saga/effects';
import appActions from '../../../appActions';
import { crudSaga, querySaga } from '../../../utils/reduxHelper';

function* resetTaskNotificationSaga() {
    yield put(appActions.TASKNOTIFICATION_RESET_SUCCESS());
}

function* watchTaskNotificationUpdateRequest() {
    yield takeLatest(
        appActions.TASKNOTIFICATION_UPDATE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/communication/v1/task-notification/update',
                appActions.TASKNOTIFICATION_UPDATE_SUCCESS,
                appActions.TASKNOTIFICATION_UPDATE_FAILURE,
                'PUT',
            );
        },
    );
}

function* watchTaskNotificationCreateRequest() {
    yield takeLatest(
        appActions.TASKNOTIFICATION_CREATE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/communication/v1/task-notification/save',
                appActions.TASKNOTIFICATION_CREATE_SUCCESS,
                appActions.TASKNOTIFICATION_CREATE_FAILURE,
                'POST',
            );
        },
    );
}

function* watchTaskNotificationDeleteRequest() {
    yield takeLatest(
        appActions.TASKNOTIFICATION_DELETE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                `/communication/v1/task-notification`,
                appActions.TASKNOTIFICATION_DELETE_SUCCESS,
                appActions.TASKNOTIFICATION_DELETE_FAILURE,
                'DELETE',
            );
        },
    );
}

function* watchTaskNotificationGetAllRequest() {
    yield takeLatest(
        appActions.TASKNOTIFICATION_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/communication/v1/task-notification',
                appActions.TASKNOTIFICATION_GET_ALL_SUCCESS,
                appActions.TASKNOTIFICATION_GET_ALL_FAILURE,
            );
        },
    );
}

export default function* taskNotificationWatcher() {
    yield* watchTaskNotificationUpdateRequest();
    yield* watchTaskNotificationCreateRequest();
    yield* watchTaskNotificationGetAllRequest();
    yield* watchTaskNotificationDeleteRequest();
    yield takeLatest(
        appActions.TASKNOTIFICATION_RESET_REQUEST.type,
        resetTaskNotificationSaga,
    );
    // Add other watchers here
}
